export type OnboardingVehicleState = {
  vehicleId: string;
  make: string;
  model: string;
  year: string;
  color: string;
  licensePlate: string;
  vin: string;
  bodyType: string;
  odometer: number;
  hub: string;
  plan: string;
};

export type OnboardingVehicleAction =
  | { type: "SET_VEHICLE_ID"; payload: string }
  | { type: "SET_MAKE"; payload: string }
  | { type: "SET_MODEL"; payload: string }
  | { type: "SET_YEAR"; payload: string }
  | { type: "SET_COLOR"; payload: string }
  | { type: "SET_LICENSE_PLATE"; payload: string }
  | { type: "SET_VIN"; payload: string }
  | { type: "SET_BODY_TYPE"; payload: string }
  | { type: "SET_ODOMETER"; payload: number }
  | { type: "SET_HUB"; payload: string }
  | { type: "SET_PLAN"; payload: string }
  | { type: "SET_ALL"; payload: Partial<OnboardingVehicleState> };

export const onboardingVehicleInitialState: OnboardingVehicleState = {
  vehicleId: "",
  make: "",
  model: "",
  year: "",
  color: "",
  licensePlate: "",
  vin: "",
  bodyType: "",
  odometer: 0,
  hub: "",
  plan: "",
};

export function onboardingVehicleReducer(state: OnboardingVehicleState, action: OnboardingVehicleAction): OnboardingVehicleState {
  switch (action.type) {
    case "SET_VEHICLE_ID":
      return { ...state, vehicleId: action.payload };
    case "SET_MAKE":
      return { ...state, make: action.payload };
    case "SET_MODEL":
      return { ...state, model: action.payload };
    case "SET_YEAR":
      return { ...state, year: action.payload };
    case "SET_COLOR":
      return { ...state, color: action.payload };
    case "SET_LICENSE_PLATE":
      return { ...state, licensePlate: action.payload };
    case "SET_VIN":
      return { ...state, vin: action.payload };
    case "SET_BODY_TYPE":
      return { ...state, bodyType: action.payload };
    case "SET_ODOMETER":
      return { ...state, odometer: action.payload };
    case "SET_HUB":
      return { ...state, hub: action.payload };
    case "SET_PLAN":
      return { ...state, plan: action.payload };
    case "SET_ALL":
      return { ...state, ...action.payload };
    default:
      console.log(`Error - incorrect action sent ${JSON.stringify(action)} ${JSON.stringify(state)}`);
      return state;
  }
}